export function initQuickView(root) {
  if (!root || root.__quickViewInited) {
    return;
  }

  root.__quickViewInited = true;

  const button = root.querySelector('button');
  if (!button) {
    return;
  }

  button.removeEventListener('click', (e) => {
    handleQuickViewClick(e, root);
  });

  button.addEventListener('click', (e) => {
    handleQuickViewClick(e, root);
  });

  root.addEventListener('mousemove', () => {}, { once: true });
}

function handleQuickViewClick(e, root) {
  e.preventDefault();
  fetchUrl(root);
}

async function fetchUrl(root) {
  setLoading(root, true);

  const { url } = root.dataset;
  if (!url) {
    return;
  }

  const result = await fetch(url);
  if (result.status === 200) {
    const textResults = await result.text();

    setLoading(root, false);

    document.getElementById('popupQuickview')?.closest('.shopify-section')?.remove();

    document.body.insertAdjacentHTML('beforeend', textResults);

    setTimeout(() => {
      document.querySelector('#popupQuickview pdp-gallery-slide')?.load?.();

      document.getElementById('popupQuickview')?.open();
    }, 100);

    document.dispatchEvent(new CustomEvent('quickview-append'));
  } else {
    setLoading(root, false);
  }
}

function setLoading(root, isLoading) {
  const button = root.querySelector('button');
  if (!button) {
    return;
  }

  if (isLoading) {
    button.setAttribute('aria-busy', 'true');
    button.classList.add('disabled');
    button.querySelector('.svg-loading').classList.remove('none');
    button.querySelector('.btn-quick-view-content').classList.add('none');
  } else {
    button.removeAttribute('aria-busy');
    button.classList.remove('disabled');
    button.querySelector('.svg-loading').classList.add('none');
    button.querySelector('.btn-quick-view-content').classList.remove('none');
  }

  document.getElementById('popupQuickview')?.classList.toggle('loading', isLoading);
}
